import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class DropdownsSingleSelectComponent extends Component {
  @service store;

  @tracked textFilter = '';

  @tracked tippyInstance = null;

  get ComponentName() {
    return this.args.tippy ? 'Tippy' : 'empty-component';
  }

  get trigger() {
    return this.args?.trigger ?? 'click';
  }

  get offset() {
    return this.args?.offset ?? [0, 8];
  }

  get placement() {
    return this.args.placement ?? 'bottom-start';
  }

  get interactive() {
    return this.args.interactive ?? true;
  }

  get options() {
    return this.args.options;
  }

  get displayOptions() {
    if (!this.textFilter) return this.options;
    return this.options.filter((item) =>
      item.label.toLowerCase().includes(this.textFilter.toLowerCase()),
    );
  }

  get value() {
    return this.args.value;
  }

  get searchable() {
    if (this.args.hideSearch === true) return false;
    return this.options?.length >= 6;
  }

  @action
  handleSearch(text) {
    this.textFilter = text;
  }

  @action
  onShown() {
    document.querySelector('#searchable')?.focus?.();
  }

  @action
  onCreate(e) {
    this.tippyInstance = e;
  }

  @action
  handleClearSelection() {
    this.args?.handleClearSelection();
    this.tippyInstance.hide();
  }

  @action
  onSelect(e) {
    this.args.onSelect(e);
  }

  @action
  focusSearch() {
    const search = document.querySelector('.inner-tippy-dropdown #searchable');
    if (search) search.focus();
  }
}
